import * as React from 'react'
import {Alert, Col, Form, Input, Modal, notification, Row, Spin} from 'antd';
import {FormComponentProps} from 'antd/lib/form';
import {withTranslation, WithTranslation} from 'react-i18next';
import {NewProjectItem, NewProjectStore} from 'src/stores/projects-store';
import {connect} from 'redux-scaffolding-ts'
import {nameof} from 'src/core/utils/object';
import autobind from 'autobind-decorator';
import {GetFieldDecoratorOptions} from 'antd/lib/form/Form';
import {formatMessage} from '../../../core/services/http.service';
import EditableTooltip from '../../../components/editable-tooltip/tooltip';
import moment from 'moment-timezone';
import {Moment} from 'moment';
import LabelIcon from '../../../components/editable-tooltip/label-icon';

let FormItem = Form.Item;

interface NewProjectViewProps {
    companyId: string,
    onClose: (id: string | undefined, item?: NewProjectItem) => void;
    onOk?: (id: string | undefined) => void,
    firstTaskOptional: boolean,
    companyAllowCir: boolean,
    companyAllowCii: boolean,
    isOnlyUser?: boolean
}

interface NewProjectViewState {
    restrictProjectFields: boolean,
    isBusy: boolean,
}

interface ClassFormBodyProps extends WithTranslation {
    item: NewProjectItem | undefined;
    onSave?: () => Promise<any>;
    getFieldDecorator<T extends Object = {}>(id: keyof T, options?: GetFieldDecoratorOptions): (node: React.ReactNode) => React.ReactNode;
    firstTaskOptional: boolean;
    restrictProjectFields?: boolean;
    companyAllowCir: boolean,
    companyAllowCii: boolean,
    isOnlyUser?: boolean
}

interface ClassFormBodyState {
    startDate?: Moment
    endDate?: Moment | null
    isSelectingDate?: boolean
    addFirstTask: boolean
}

class ProjectFormBody extends React.Component<ClassFormBodyProps, ClassFormBodyState> {
    constructor(props: ClassFormBodyProps) {
        super(props);
        this.state = {
            addFirstTask: false,
        }
    }

    render() {
        const { t } = this.props;
        var item = this.props.item || {} as NewProjectItem;
        return (
            <Form
                id="modaForm"
                onKeyUp={(e) => { if (e.keyCode === 13 && this.props.onSave) { this.props.onSave(); } }}
                onSubmit={() => { if (this.props.onSave) { this.props.onSave(); } }}
            >
                <Row gutter={24}>
                    <Col span={24}>
                        <FormItem label={t("Name")}>
                            {this.props.getFieldDecorator(nameof<NewProjectItem>('title'), {
                                initialValue: item.title,
                                rules: [{ required: true, message: t('Title required') },
                                    { max: 255, message: t('Maximum length is 255 characters') },
                                    { whitespace: true, message: t('Title required') }],
                            })(
                                <Input placeholder={t("Title")} type="text" disabled={this.props.restrictProjectFields} maxLength={255}/>
                            )}
                        </FormItem>
                    </Col>
                </Row>

                {(this.state.addFirstTask || !this.props.firstTaskOptional) &&
                    <div>

                        <Row gutter={24}>
                            <Col span={12}>
                                <EditableTooltip name='new-project-initial-task' noIcon>
                                    <FormItem label={(
                                        <LabelIcon>
                                            { t("Task name")}
                                        </LabelIcon>
                                    )}>
                                        {this.props.getFieldDecorator(nameof<NewProjectItem>('firstTaskTitle'), {
                                            initialValue: item.firstTaskTitle,
                                            rules: [{ required: this.state.addFirstTask || !this.props.firstTaskOptional, message: t('Task name required') },
                                                { max: 255, message: t('Maximum length is 255 characters') },
                                                { whitespace: true, message: t('Task name required') }],
                                        })(
                                            <Input placeholder={t("Task name")} type="text" maxLength={255} />
                                        )}
                                    </FormItem>
                            </EditableTooltip>
                            </Col>
                        </Row>
                    </div>
                }
            </Form>
        )
    }
}

@connect(["newProject", NewProjectStore])
class NewProjectView extends React.Component<NewProjectViewProps & WithTranslation & FormComponentProps, NewProjectViewState> {
    private get newProjectStore() {
        return (this.props as any).newProject as NewProjectStore;
    }

    constructor(props: NewProjectViewProps & WithTranslation & FormComponentProps) {
        super(props);
        this.state = {
            restrictProjectFields: false,
            isBusy: false
        }
        this.newProjectStore.createNew({} as any);
        this.newProjectStore.changeUrl(props.companyId);
    }

    componentWillReceiveProps(nextProps: NewProjectViewProps) {
        if (this.newProjectStore.state.result && this.newProjectStore.state.result.isSuccess)
            this.props.onClose((this.newProjectStore.state.result as any).aggregateRootId, this.newProjectStore.state.item)
    }
    private countDownNotification(_notification: any, message: string, description: string, key: string) {
        let secondsToGo = 4;
        _notification({
            key: key,
            message: message + `(${secondsToGo}).`,
            description: description
        });
        const timer = setInterval(() => {
            secondsToGo -= 1;
            _notification({
                key: key,
                message: message + `(${secondsToGo}).`,
                description: description,
                onClose: () => clearInterval(timer),
            });
        }, 1000);
        setTimeout(() => {
            clearInterval(timer);
            notification.close(key);
        }, secondsToGo * 1000);
    }

    @autobind
    private onCreateNewItem() {
        var self = this;
        const { t } = this.props;
        return new Promise((resolve, reject) => {
            self.props.form.validateFields(event => {
                var values = self.props.form.getFieldsValue();
                var { fromDate, toDate } = values

                //format Start date to correct unix value
                if (fromDate) {
                    values = { ...values, fromDate: values.fromDate.unix() }
                } else {
                    fromDate = moment().utc().startOf("day").unix()
                    values = { ...values, fromDate: fromDate }
                }

                //format End date to correct unix value if provided
                if (toDate) {
                    values = { ...values, toDate: values.toDate.unix() }
                }

                if (!event) {
                    values = {
                        ...values,
                        companyId: this.props.companyId,
                        ignoreProjectCreation: this.state.restrictProjectFields
                    };

                    self.newProjectStore.change(values);
                    self.newProjectStore.post().then(result => {
                        if (this.props.onOk) this.props.onOk(result.identifier)
                        if (result.isSuccess) {
                            resolve();
                            this.countDownNotification(notification.success, t('Success'), t('The request email has been sent to your manager'), 'success')

                        } else {
                            reject();
                            this.countDownNotification(notification.error, t('Error'), t('There was an error'), 'fail')
                        }
                    }).catch(reason => {
                        this.setState({ restrictProjectFields: this.newProjectStore.isTaskError })
                    });
                }
            });
        })
    }

    @autobind
    private onSendEmailToManager() {
        this.setState({ isBusy: true });
        this.newProjectStore.changeUrl(this.props.companyId);
        var values = this.props.form.getFieldsValue();
        this.newProjectStore.postSendEmailManager(values.firstTaskTitle, values.title);
        this.setState({ isBusy: false });
        this.newProjectStore.clear();
        this.props.onClose(undefined);
    }

    @autobind
    private onCancelNewItem() {
        this.newProjectStore.clear();
        this.props.onClose(undefined);
    }

    public render() {
        const { getFieldDecorator } = this.props.form;
        const { t } = this.props;
        return (
            <>
                <Modal
                    maskClosable={false}
                    visible
                    onCancel={this.onCancelNewItem}
                    onOk={this.onCreateNewItem}
                    closable={false}
                    width='800px'
                    okText={t("OK")}
                    cancelText={t("Cancel")}
                    title={t("New project")}>
                    {this.newProjectStore.state.result && !this.newProjectStore.state.result.isSuccess && 
                        formatMessage(this.newProjectStore.state.result) != "A project with this title already exists" &&
                        <Alert type='error'
                            message={t("Error")}
                            description={t(formatMessage(this.newProjectStore.state.result))}
                        />
                    }
                    <Spin spinning={this.newProjectStore.state.isBusy}>
                        <ProjectFormBody
                            i18n={this.props.i18n}
                            t={this.props.t}
                            tReady={this.props.tReady}
                            item={this.newProjectStore.state.item}
                            getFieldDecorator={getFieldDecorator}
                            onSave={this.onCreateNewItem}
                            firstTaskOptional={this.props.firstTaskOptional}
                            restrictProjectFields={this.state.restrictProjectFields}
                            companyAllowCir={this.props.companyAllowCir}
                            companyAllowCii={this.props.companyAllowCii}
                            isOnlyUser={this.props.isOnlyUser}
                        />
                    </Spin>
                </Modal>

                {this.newProjectStore.state.result && !this.newProjectStore.state.result.isSuccess &&
                    formatMessage(this.newProjectStore.state.result) == "A project with this title already exists" &&
                    <Modal
                        onOk={this.onSendEmailToManager}
                        visible
                        okText={t("OK")}
                        maskClosable={true}
                        closable={true}
                        onCancel={this.onCancelNewItem}
                        title={t('Confirmation required')}>
                        <div>
                            <p>
                                {t("The project already exists.")}
                            </p>
                            <p>
                                {t("Would you like to send an email to the manager to assign this project to you?")}
                            </p>
                        </div>
                        <Spin spinning={this.state.isBusy}></Spin>
                    </Modal >
                }
            </>
           
        );
    }
}

// Wire up the React component to the Redux store
export default withTranslation()(Form.create({})(NewProjectView as any) as any) as any as React.ComponentClass<NewProjectViewProps>;